import styled from 'styled-components';
import { MOBILE_BREAKPOINT, TOUCH_TARGET } from '../../constants/mobile';

const mobile = `@media (max-width: ${MOBILE_BREAKPOINT - 1}px)`;

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  background: #0b0e11;
  color: #eaecef;
`;

export const Body = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${mobile} {
    padding: 12px;
    gap: 12px;
  }
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  align-items: start;

  ${mobile} {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
`;

export const Card = styled.section`
  background: #181a20;
  border: 1px solid #2b3139;
  border-radius: 8px;
  padding: 16px;
  min-width: 0;

  ${mobile} {
    padding: 12px;
  }
`;

export const CardTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 600;
  color: #eaecef;
`;

export const SubTitle = styled.div`
  margin: 16px 0 8px;
  font-size: 13px;
  font-weight: 600;
  color: #b7bdc6;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
  color: #b7bdc6;
  font-size: 13px;
`;

export const Muted = styled.span`
  color: #848e9c;
  font-size: 12px;
`;

/** M T W T F as one segmented strip, full width so each day is a comfortable target. */
export const DayStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  border: 1px solid #2b3139;
  border-radius: 6px;
  overflow: hidden;
`;

export const DayCell = styled.button<{ $on: boolean }>`
  min-height: ${TOUCH_TARGET}px;
  border: 0;
  border-right: 1px solid #2b3139;
  background: ${(p) => (p.$on ? 'rgba(14, 203, 129, 0.18)' : '#1e2329')};
  color: ${(p) => (p.$on ? '#0ecb81' : '#b7bdc6')};
  font-weight: ${(p) => (p.$on ? 600 : 400)};
  font-size: 14px;
  cursor: pointer;

  &:last-child {
    border-right: 0;
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
  &:focus-visible {
    outline: 2px solid #0ecb81;
    outline-offset: -2px;
  }
`;

/** 1–31 as a calendar: 8 across on desktop (the mock), 7 on a phone so cells stay ≥ 40px. */
export const MonthGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(8, minmax(0, 1fr));
  gap: 4px;

  ${mobile} {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
`;

export const MonthCell = styled(DayCell)`
  min-height: 36px;
  border: 1px solid #2b3139;
  border-radius: 4px;

  &:last-child {
    border-right: 1px solid #2b3139;
  }

  ${mobile} {
    min-height: 40px;
  }
`;

export const WeightRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px 32px;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;

  ${mobile} {
    grid-template-columns: minmax(0, 1fr) 104px ${TOUCH_TARGET}px;
  }
`;

export const TotalBar = styled.div<{ $ok: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  margin-top: 4px;
  border-radius: 6px;
  font-size: 13px;
  background: ${(p) => (p.$ok ? 'rgba(14, 203, 129, 0.08)' : 'rgba(240, 185, 11, 0.08)')};
  color: ${(p) => (p.$ok ? '#0ecb81' : '#f0b90b')};
`;

export const Summary = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  align-items: center;

  ${mobile} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
  }
`;

export const Stat = styled.div`
  min-width: 0;

  .label {
    color: #848e9c;
    font-size: 12px;
  }
  .value {
    color: #eaecef;
    font-size: 16px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;

  ${mobile} {
    grid-column: 1 / -1;
  }
`;

/** Phone: Save / Deposit pinned above the tab bar, always reachable. */
export const MobileActionBar = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  gap: 8px;
  padding: 10px 12px calc(10px + env(safe-area-inset-bottom));
  background: #181a20;
  border-top: 1px solid #2b3139;

  .ant-btn {
    flex: 1;
    height: ${TOUCH_TARGET}px;
  }
`;
